import React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const ReCaptchaButton = ({
  title,
  id,
  action,
  children,
  buttonHandler,
}: {
  title: string;
  action?: string;
  id?: string;
  children: string | React.ReactNode;
  buttonHandler?: (token?: string) => void;
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = async (e) => {
    e.target.disabled=true;
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }
    
    const captchaToken = await executeRecaptcha(action);
    buttonHandler(captchaToken);
    e.target.disabled=false;
  };

  return (
    <button id={id ?? ''} title={title}
      className="ontario-button ontario-button--primary recaptcha-button"
      onClick={handleReCaptchaVerify}
    >
      {children}
    </button>
  );
};

export default ReCaptchaButton;